module.exports = __webpack_public_path__ + "static/media/pulsidS.0b81278c.webp";